import React, { useState } from 'react';
import { InfoSerialNumberModal } from 'components/modals/InfoSerialNumberModal';

export const InfoSerialNumber = () => {
	const [isOpen, setIsOpen] = useState(false);

	const toggle = () => {
		setIsOpen(!isOpen);
	};
	return (
		<div style={{ textAlign: 'right', marginTop: 8 }}>
			{isOpen ? <InfoSerialNumberModal toggle={toggle} /> : null}
			<span className="body-small primary-color" style={{ cursor: 'pointer' }} onClick={toggle}>
				¿Dónde encuentro mi N° de serie?
			</span>
		</div>
	);
};
